'use client';

import SmallerScreensModal from '@/components/modal/smaller-screens-modal';
import { useAuth } from '@/hooks/mutate/use-auth';
import { signInSchema } from '@/lib/validator/auth';
import { FormLoginValue } from '@/types/auth';
import { useForm, yupResolver } from '@mantine/form';
import { useSearchParams } from 'next/navigation';
import { useState } from 'react';
import LoginContent from './login-content';

const initialValues: FormLoginValue = {
  email: '',
  password: '',
};

const LoginClient = () => {
  const searchParams = useSearchParams();
  const { isLoading, onLogin, onSocialAuth, isLoadingProvider } =
    useAuth(searchParams);
  const [error, setError] = useState('');
  const form = useForm({
    initialValues,
    validate: yupResolver(signInSchema),
  });

  return (
    <>
      <LoginContent
        {...{
          isLoading,
          onLogin,
          isLoadingProvider,
          onSocialAuth,
          form,
          error,
          setError,
        }}
      />
      <SmallerScreensModal />
    </>
  );
};

export default LoginClient;
